export class File {
  constructor(data = {}) {
    this.url = data?.url || "";
    this.type = data?.type || "";
    this.mimeType = data?.mime_type || "";
  }
}
